<template>
  <div class="flex flex-1 items-center justify-center bg-gray-100 h-screen text-2xl">
    404
  </div>
  <!-- <splide :options="options">
    <splide-slide>
      <img src="https://api.23paskal.id/images/dZRMndSm_3uEhrMo8HBzcHqhQ.png">
    </splide-slide>
    <splide-slide>
      <img src="https://api.23paskal.id/images/dZRMndSm_3uEhrMo8HBzcHqhQ.png">
    </splide-slide>
    <splide-slide>
      <img src="https://api.23paskal.id/images/dZRMndSm_3uEhrMo8HBzcHqhQ.png">
    </splide-slide>
  </splide> -->
</template>

<script>
  // import '@splidejs/splide/dist/css/themes/splide-default.min.css';
  // import '@splidejs/splide/dist/css/themes/splide-sea-green.min.css';
  // import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
  export default {
    name: 'NotFound',
    data() {
      return {
        // options: {
        //   rewind : true,
        //   width  : 800,
        //   gap    : '1rem',
        // },
      };
    },
  }
</script>
